import { createFileRoute, redirect } from '@tanstack/react-router'
import { SELLERS_TABS } from '~/components/routes/sellers/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

// Chaque onglet est une URL distincte ; /sellers redirige vers le premier onglet accessible
// directement au chargement de la route.
export const Route = createFileRoute('/_authenticated/sellers/')({
  staticData: {
    permission: { any: SELLERS_TABS.map((tab) => tab.permission) },
  },
  beforeLoad: ({ context }) => {
    const first = SELLERS_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )
    throw redirect({ to: first?.to ?? SELLERS_TABS[0].to })
  },
})
withRoutePermissions(Route)
